module.exports = __webpack_public_path__ + "static/ykwc-logo-sm.e78ccaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ykwc-logo-sm.png
// module id = 886
// module chunks = 114276838955818